module.exports = __webpack_public_path__ + "static/media/WFDF_hand_signals.015f52ae.jpeg";